import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { HeaderService } from 'src/app/core/header/header.service';
import { DialogComponent } from './../../core/dialog/dialog.component';
import { GridbuttonComponent } from './../../core/gridbutton/gridbutton.component';
import { ActualService } from './../../service/actual.service';
import { DateTime } from 'luxon';
import { SupplierCellRendererComponent } from 'src/app/core/supplier-cell-renderer/supplier-cell-renderer.component';

@Component({
    selector: 'app-actual',
    templateUrl: './actual.component.html',
    styleUrls: ['./actual.component.scss'],
    standalone: false // NOSONAR
})
export class ActualComponent implements OnInit {

  @ViewChild('agGrid', { static: true }) agGrid;

  // Component Properties
  successMessage = '';
  errorMessage = '';
  fiscalYear: any;
  enableError = false;
  enableSubmit = false;
  enableSubmitDate = false;
  enableSubmitTimeZone = false;
  enableSubmitRoute = false;
  enablePdfChoosen = false;
  routeErrorMsg = "";
  timeZoneErrorMsg = "";
  pdfErrorMsg = "";
  dateErrorMsg = "";
  route = "";
  pickDate?: Date;
  dispatchDate?: Date;
  unloadDate?: Date;
  routeDate?: Date;
  timeZone = "";
  errormsg = "";
  timeZoneChoosen: string = 'EST';
  pdfTypeChoosen: string = 'O';
  enableGrid = false;
  rowData: any[] = [];
  tempData: any[] = [];
  rowCount: any;
  frameworkComponents: any;
  pdfErrorCodes = ['8', '100', '101', '102', '103', '104', '300', '301'];
  pdfLinks: any[] = [];
  // Grid Variables
  gridApi: any;
  gridColumnApi: any;
  currentPageNo: any;
  currentPageBoolean = false;
  totalPage: any;
  currentPageForTotalPage: any;
  isLastPageFound: any;
  paginationPageSize = 20;
  setPagination = true;

  // Truck Types
  truckTypeChoosen!: { trailerTypeId: number, truck: string, trailerType: string };
  truckTypesTemp: any = [];
  truckTypes: { trailerTypeId: number, truck: string, trailerType: string }[] = [];

  // Grid Configurations
  columnDefs;
  icons;
  defaultColDef;
  dynamicHeight: number;
  context: any;
  pipe: DatePipe;
  userDetails: string | null; date_format = 'MM/dd/yyyy HH:mm'

  ngOnInit(): void {
    this.pipe = new DatePipe('en-US');
    this.truckTypesTemp = localStorage.getItem('Truck-Types');
    this.userDetails = localStorage.getItem('user-info');
    this.truckTypes = this.truckTypesTemp ? JSON.parse(this.truckTypesTemp) : [];
    this.truckTypeChoosen = this.truckTypes[0];
    this.headerService.updateUserRole.emit();
  }

  //end

  constructor(private  readonly actService: ActualService, private readonly ngxUiLoaderService: NgxUiLoaderService,
    private readonly dialog: MatDialog,
    private readonly headerService: HeaderService) {
    this.pipe = new DatePipe('en-US');
    this.dynamicHeight = 0.665 * (window.innerHeight);
    this.frameworkComponents = {
      buttonRenderer: GridbuttonComponent,
      supplierRenderer: SupplierCellRendererComponent
    }
    // booting up the ag grid
    this.context = { componentParent: this };
    this.initializeGridConfig();
  }

  private initializeGridConfig() {
    this.columnDefs = [
      { headerName: "Route", field: "route", hide: true },
      { headerName: "Run", field: "run", hide: true },
      { headerName: "Route-Run", field: "routeRun", width: 20, filter: "agTextColumnFilter" },
      { headerName: "Dock", field: "dock", width: 80, filter: "agTextColumnFilter" },
      {
        headerName: 'Supplier',
        field: 'supplier',
        width: 60,  // increase width if too narrow
        filter: 'agTextColumnFilter',
        cellRenderer: SupplierCellRendererComponent,
        autoHeight: false,    // Important: disable autoHeight to allow ellipsis
        wrapText: false,      // Disable wrapping, otherwise ellipsis won't work
        cellClass: 'supplier-cell'
      },
      
      { headerName: "Truck", field: "truck", hide: true },
      { headerName: "TrailerId", field: "trailerId", hide: true },
      { headerName: "Route Date", field: "routeDate", width: 60, filter: "agTextColumnFilter" },
      { headerName: "Dispatch", field: "dispatchDate", width: 60, filter: "agTextColumnFilter" },
      { headerName: "Pick Up", field: "pickUpDate", width: 60, filter: "agTextColumnFilter" },
      { headerName: "Unload", field: "unload", width: 60, filter: "agTextColumnFilter" },
      { headerName: "Timezone", field: "timezone", hide: true },
      { headerName: "Action", field: "Action", width: 60, cellRenderer: GridbuttonComponent, cellRendererParams: { onClick: this.onBtnClick.bind(this), label: 'View' } }
    ];

    this.icons = { sortUnSort: '<i class="fa fa-sort" style="font-weight:bold;color:black;"/>' };
    this.defaultColDef = { minWidth: 80, floatingFilter: true, wrapText: true, suppressMovable: true,suppressHeaderFilterButton: true ,suppressCellSelection: true };
  }


  validateInput() {
    this.routeErrorMsg = this.route.length == 3 || this.route.length == 4  ? '' : 'Route should be 3 or 4 characters';  // NOSONAR
    this.enableError = this.routeErrorMsg !=  ""; // NOSONAR
    if (!this.enableError) {
      this.validatePickDate();
      this.validateTimeZone();
      this.validatePdfChoosen();
    }
    this.enableSubmitRoute = !this.enableError;
    this.validateSubmit();
  }

  validateSubmit() {
    this.enableSubmit = this.enableSubmitDate && this.enableSubmitRoute && this.enableSubmitTimeZone && this.enablePdfChoosen;
  }

  validatePickDate() {
    this.dateErrorMsg = (!this.pickDate && !this.routeDate && !this.dispatchDate && !this.unloadDate) ? 'Pick Route or Dispatch or Pick Up or or Unload Date' : '';
    this.enableError = this.dateErrorMsg !=  ""; // NOSONAR
    this.enableSubmitDate = !this.enableError;
    this.validateTimeZone();
    this.validateSubmit();
  }

  validateTimeZone() {
    this.timeZoneErrorMsg = this.timeZoneChoosen ? '' : 'Pick Time Zone';
    this.enableError = this.timeZoneErrorMsg !=  ""; // NOSONAR
    this.enableSubmitTimeZone = !this.enableError;
    this.validateSubmit();
  }

  public OnDateChange(event, type): void {
    if (type == 'dispatch') {  // NOSONAR
      this.dispatchDate = event;
    }
    if (type == 'pickup') {  // NOSONAR
      this.pickDate = event;
    }
    if (type == 'unloadDt') {  // NOSONAR
      this.unloadDate = event;
    }
    if (type == 'routeDt') {  // NOSONAR
      this.routeDate = event;
    }
    this.validatePickDate();
  };

  validatePdfChoosen() {
    this.pdfErrorMsg = this.pdfTypeChoosen ? '' : 'Please select a PDF type!';
    this.enableError = this.pdfErrorMsg !=  ""; // NOSONAR
    this.enablePdfChoosen = !this.enableError;
    this.validateSubmit();
  }

  public enableSubmitBut(flag: boolean) { 
    if (flag) { // NOSONAR
      this.enableSubmit = false;
    } else {
      this.enableSubmit = true;
    }
  };



  onBtnClick(e) {
    this.ngxUiLoaderService.start("loader-01");
    const userInfo = localStorage.getItem('user-info');
    const userDetails = userInfo ? JSON.parse(userInfo) : [];

    // Prepare request payload
    const requestData = {
      route: e.rowData.route,
      run: e.rowData.run,
      truck: e.rowData.truck,
      trailerId: e.rowData.trailerId,
      unloadDate: this.dateFormatJava(e.rowData.unload),
      routeDate: this.dateFormatJava(e.rowData.routeDate),
      pdfType: this.pdfTypeChoosen,
      userDetails: userDetails // Attach user details retrieved from local storage
    };

    this.actService.getActualDataPdf(requestData).subscribe(result => { // NOSONAR
      if (result && result.MLP_OPTIMIZE_LOAD && result.MLP_OPTIMIZE_LOAD.length > 0) {
        this.pdfLinks = result.MLP_OPTIMIZE_LOAD;
      }



      if (this.pdfLinks.length > 0) {
        const errorExists = this.pdfLinks.some(link => link.ERROR_CODE && link.ERROR_CODE !=  "0"); // NOSONAR
        // Check for invalid PDF URL (i.e., null or empty string)
        const validPdfLink = this.pdfLinks.find(pdf => pdf.PDF_URL && pdf.PDF_URL.trim() !=  'null' && pdf.PDF_URL.trim() !=  ''); // NOSONAR
        if (validPdfLink) {
          // If we have one valid PDF, open it
          if (this.pdfLinks.length == 1) {  // NOSONAR
            console.info("PDF URL:", this.pdfLinks[0].PDF_URL);
            window.open(this.pdfLinks[0].PDF_URL, "_blank");
          } else if (this.pdfLinks.length > 1) {
            this.ngxUiLoaderService.stop("loader-01");
            const dialogData = {
              pdfLinks: this.pdfLinks,
              message: errorExists
                ? "Multiple PDF URLs exist with errors. Please check and click to open."
                : "Multiple PDF URLs exist. Please click to open.",
              buttonText: {
                cancel: 'Back'
              }
            };
            this.openDialog(dialogData);
          }
        } else {
          // If no valid PDF URL found
          this.ngxUiLoaderService.stop("loader-01");
          const dialogData = {
            message: "No Valid PDF available with error code " + result.ERROR_CODE,
            buttonText: {
              cancel: 'Back'
            }
          };
          this.openDialog(dialogData);
        }

      } else {
        // No PDFs available
        this.ngxUiLoaderService.stop("loader-01");
        const errorExists = this.pdfLinks.some(link => link.ERROR_CODE && link.ERROR_CODE !=  "0"); // NOSONAR
        const message = errorExists
          ? "PDF Links not available. Check the error message below."
          : "No PDF Links available. Please check the error message below.";
        console.info(message);

        const dialogData = {
          pdfLinks: this.pdfLinks,
          errorExists: errorExists,
          message: message,
          buttonText: {
            cancel: 'Back'
          }
        };
        this.openDialog(dialogData);
      }
      this.ngxUiLoaderService.stop("loader-01");
    });
  };

  openDialog(data) {
    const dialogRef = this.dialog.open(DialogComponent, {
      data: data
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        const a = document.createElement('a');
        a.click();
        a.remove();
      }
    });
  };

  search() {

    console.info("USer details after search" + this.userDetails);
    this.resetSearchData();

    if (this.isInvalidInput()) {
      this.enableError = true;
      return;
    }

    this.executeSearch();
  }

  private resetSearchData() {
    this.rowData = [];
    this.tempData = [];
    this.enableError = false;
  }

  private isInvalidInput(): boolean {
    if (!this.route?.trim()) {
      this.setError('Please Enter Route Code!');
      return true;
    }
    if (!this.pickDate && !this.routeDate && !this.dispatchDate && !this.unloadDate) {
      this.setError('Please Pick either Route or  Dispatch or Pick-up or Unload Date!');
      return true;
    }
    if (!this.timeZoneChoosen?.trim()) {
      this.setError('Please Pick either Time Zone!');
      return true;
    }
    if (!this.pdfTypeChoosen?.trim()) {
      this.setError('Please select a PDF type!');
      return true;
    }
    return false;
  }

  private setError(message: string) {
    this.enableError = true;
    this.errormsg = message;
  }

  private executeSearch() {
    this.enableGrid = true;
    const requestData = {
      "route": this.route,
      "routeDate": this.routeDate,
      "pickUpDate": this.pickDate,
      "dispatchDate": this.dispatchDate,
      "unloadDate": this.unloadDate,
      "timezone": this.timeZoneChoosen
    };

    this.ngxUiLoaderService.start("loader-01");

    this.actService.searchActualData(requestData).subscribe(result => {
      this.processSearchResult(result);
      this.ngxUiLoaderService.stop("loader-01");
    });
  }

  private processSearchResult(result: any) {
    JSON.parse(result)?.forEach(e => {
      const obj = {
        "route": e.route,
        "run": e.run,
        "supplier": e.supplier,
        "dock": e.dock,
        "truck": this.truckTypeChoosen?.trailerType || null,
        "trailerId": this.truckTypeChoosen?.trailerTypeId || null,
        "routeDate":this.dateTzConverter( e.routeDate,e.timezone),
        "dispatchDate":this.dateTzConverter( e.dispatchDate,e.timezone),
        "pickUpDate": this.dateTzConverter( e.pickUpDate,e.timezone),
        "unload": this.dateTzConverter( e.unload,e.timezone),
        "timezone": e.timezone,
        "routeRun": `${e.route || ''}-${e.run || ''}`
      };

      this.tempData.push(obj);
    });

    this.rowData = this.tempData;
    this.rowCount = this.rowData.length;
  }



  convertDateFormat(date: any) {
    return this.pipe.transform(date, this.date_format, 'EST');
  };

  dateFormatJava(date: any) {
    const latest_date = this.pipe.transform(date, 'dd-MMM-yyyy');
    return latest_date;
  };

  dateTzConverter(date: string, neededTz: string) {
    if (date == undefined || date == null) {  // NOSONAR
      return null;
    }
    const test = DateTime.fromFormat(
      date.substring(0, 16),
      this.date_format,
      { zone: 'UTC', setZone: true }
    );
    return (
      test
        .setZone(neededTz)
        .toFormat(this.date_format) + ` (${neededTz})`
    );
  }


  sizeToFit() { this.gridApi.sizeColumnsToFit(); }

  goToFirstPage() { this.gridApi.paginationGoToFirstPage(); }

  goToLastPage() { this.gridApi.paginationGoToLastPage() }

  goToNexpage() { this.gridApi.paginationGoToNextPage(); }

  goToPreviousPage() { this.gridApi.paginationGoToPreviousPage()}

  onPageSizeChanged(event: any) { this.gridApi.paginationSetPageSize(Number(event.target.value)); }

  getCurrentPage(): boolean {
    this.currentPageNo = this.agGrid?.api.paginationGetCurrentPage();
    if (this.currentPageNo == 0) {  // NOSONAR
      this.currentPageBoolean = true;
    }
    else { this.currentPageBoolean = false; }
    return this.currentPageBoolean;
  }

  isLastPage(): boolean {
    this.totalPage = Number(this.agGrid?.api.paginationGetTotalPages());
    this.currentPageForTotalPage = Number(this.agGrid?.api.paginationGetCurrentPage()) + 1;
    if (this.totalPage == this.currentPageForTotalPage) {  // NOSONAR
      this.isLastPageFound = true;
    }
    else {
      this.isLastPageFound = false;
    }
    return this.isLastPageFound;
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
  }

}
